import ObjectUtil from "../../../../core/internal/util/ObjectUtil"
import { InAppMessageScheduler } from "./InAppMessageScheduler"
import { InAppMessageScheduleType } from "../InAppMessageScheduleType"

export class InAppMessageSchedulerFactory {
  constructor(private readonly schedulers: InAppMessageScheduler[]) {}

  get(scheduleType: InAppMessageScheduleType): InAppMessageScheduler {
    return ObjectUtil.requiredNotNullOrUndefined(
      this.schedulers.find((scheduler) => scheduler.supports(scheduleType)),
      () => `Unsupported InAppMessageScheduleType[${scheduleType}]`
    )
  }
}
